import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { checkCouponBalance, getVouchersByEmail } from '../../util/api';

// ================ Action types ================ //

export const CHECK_VOUCHER_REQUEST = 'app/TrackBalancePage/CHECK_VOUCHER_REQUEST';
export const CHECK_VOUCHER_SUCCESS = 'app/TrackBalancePage/CHECK_VOUCHER_SUCCESS';
export const CHECK_VOUCHER_ERROR = 'app/TrackBalancePage/CHECK_VOUCHER_ERROR';

export const FETCH_VOUCHERS_BY_EMAIL_REQUEST = 'app/TrackBalancePage/FETCH_VOUCHERS_BY_EMAIL_REQUEST';
export const FETCH_VOUCHERS_BY_EMAIL_SUCCESS = 'app/TrackBalancePage/FETCH_VOUCHERS_BY_EMAIL_SUCCESS';
export const FETCH_VOUCHERS_BY_EMAIL_ERROR = 'app/TrackBalancePage/FETCH_VOUCHERS_BY_EMAIL_ERROR';

// ================ Initial State ================ //

const initialState = {
  checking: false,
  voucherData: null,
  error: null,
  userVouchers: [],
  fetchingUserVouchers: false,
  userVouchersError: null,
};

// ================ Reducer ================ //

const TrackBalancePageReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CHECK_VOUCHER_REQUEST:
      return { ...state, checking: true, voucherData: null, error: null };
    case CHECK_VOUCHER_SUCCESS:
      return { ...state, checking: false, voucherData: action.payload, error: null };
    case CHECK_VOUCHER_ERROR:
      return { ...state, checking: false, voucherData: null, error: action.error };
    
    case FETCH_VOUCHERS_BY_EMAIL_REQUEST:
      return { ...state, fetchingUserVouchers: true, userVouchersError: null };
    case FETCH_VOUCHERS_BY_EMAIL_SUCCESS:
      return { ...state, fetchingUserVouchers: false, userVouchers: action.payload, userVouchersError: null };
    case FETCH_VOUCHERS_BY_EMAIL_ERROR:
      return { ...state, fetchingUserVouchers: false, userVouchers: [], userVouchersError: action.error };
      
    default:
      return state;
  }
};

export default TrackBalancePageReducer;

// ================ Action Creators ================ //

export const checkVoucherRequest = () => ({ type: CHECK_VOUCHER_REQUEST });

export const checkVoucherSuccess = data => ({
  type: CHECK_VOUCHER_SUCCESS,
  payload: data,
});

export const checkVoucherError = error => ({
  type: CHECK_VOUCHER_ERROR,
  error,
});

export const fetchVouchersByEmailRequest = () => ({ type: FETCH_VOUCHERS_BY_EMAIL_REQUEST });

export const fetchVouchersByEmailSuccess = data => ({
  type: FETCH_VOUCHERS_BY_EMAIL_SUCCESS,
  payload: data,
});

export const fetchVouchersByEmailError = error => ({
  type: FETCH_VOUCHERS_BY_EMAIL_ERROR,
  error,
});

// ================ Thunk ================ //

// export const checkVoucherCode = code => async (dispatch, getState, sdk) => {
//   dispatch(checkVoucherRequest());

//   try {
    

//   } catch (err) {
//     console.error('Error fetching voucher:', err);
//     dispatch(checkVoucherError('TrackBalancePanel.genericError'));
//   }
// };

export const checkVoucher = code => async (dispatch, getState, sdk) => {
  dispatch(checkVoucherRequest());

  try {
    const data = await checkCouponBalance(code);
    
    dispatch(checkVoucherSuccess(data.data));
  } catch (err) {
    console.error('Error fetching voucher:', err);
    dispatch(checkVoucherError('TrackBalancePanel.genericError'));
  }
};

const is429 = err =>
  err?.status === 429 || err?.response?.status === 429;

const RETRY_DELAY_MS = 2500;
const MAX_VOUCHER_FETCH_RETRIES = 1;

export const fetchVouchersByEmail = email => async (dispatch, getState, sdk) => {
  // Prevent duplicate requests if already fetching
  const state = getState();
  if (state.TrackBalancePage.fetchingUserVouchers) {
    return;
  }

  // Simple throttling: if we have vouchers, don't refetch unless explicitly requested
  if (state.TrackBalancePage.userVouchers && state.TrackBalancePage.userVouchers.length > 0) {
    return;
  }

  dispatch(fetchVouchersByEmailRequest());

  const attempt = async (retryCount = 0) => {
    try {
      const response = await getVouchersByEmail(email);

      if (!response || !response.data) {
        throw new Error('Invalid response from voucher API');
      }

      dispatch(fetchVouchersByEmailSuccess(response.data));
    } catch (err) {
      if (is429(err) && retryCount < MAX_VOUCHER_FETCH_RETRIES) {
        log.error(err, 'fetch-vouchers-by-email-429-retry', { email, retryCount });
        await new Promise(r => setTimeout(r, RETRY_DELAY_MS));
        return attempt(retryCount + 1);
      }

      console.error('Error fetching vouchers by email:', err);

      let errorMessage = 'TrackBalancePanel.emailFetchError';
      if (is429(err)) {
        errorMessage = 'Too many requests. Please try again later.';
      } else if (err.status === 500) {
        errorMessage = 'Server error. Please try again later.';
      } else if (err.message) {
        errorMessage = err.message;
      }

      dispatch(fetchVouchersByEmailError(errorMessage));
      log.error(err, 'fetch-vouchers-by-email-failed', { email });
    }
  };

  attempt();
};



